import { Injectable } from '@angular/core';

// RxJs
import { delay, EMPTY, of, switchMap, tap, throwError } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

// NgRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MaintainerUsersEffectsActions } from '@core/store/actions/maintainer.actions';

// Services
import { UsersService } from '@core/providers/services/maintainer/users/users.service';
import { SnackBarComponent } from '@views/global/snackbar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';



@Injectable()
export class MaintainerEffects {


  createUser$ = createEffect(() => this.actions$.pipe(
    ofType(MaintainerUsersEffectsActions.createUser),
    mergeMap(({ user }) => this.usersService.createUser(user).pipe(
      tap(() => this.showSnackBarSuccess('Usuario creado exitosamente')),
      catchError(error => {
        this.showSnackBarError('No se pudo crear el usuario');
        return throwError(MaintainerUsersEffectsActions.injectError({ error }));
      })
    ))), { dispatch: false }
  );


  getUsers$ = createEffect(() => this.actions$.pipe(
    ofType(MaintainerUsersEffectsActions.getUsers),
    mergeMap(() => this.usersService.getUsers().pipe(
      map(users => MaintainerUsersEffectsActions.injectUsers({ users })),
      catchError(error => {
        this.showSnackBarError('No se pudieron obtener los usuarios');
        return throwError(MaintainerUsersEffectsActions.injectError({ error }));
      })
    )))
  );


  fillOutUserFormSelectors$ = createEffect(() => this.actions$.pipe(
    ofType(MaintainerUsersEffectsActions.fillOutUserFormSelectors),
    mergeMap(() => this.usersService.fillOutUserFormSelectors().pipe(
      map(selectors => MaintainerUsersEffectsActions.injectUserFormSelectors({ selectors })),
      catchError(error => {
        this.showSnackBarError('No se pudieron cargar los datos para los selectores del formulario de creación');
        return throwError(MaintainerUsersEffectsActions.injectError({ error }));
      })
    )))
  );


  editUser$ = createEffect(() => this.actions$.pipe(
    ofType(MaintainerUsersEffectsActions.editUser),
    mergeMap(({ id, user }) => this.usersService.editUser(id, user).pipe(
      tap(() => this.showSnackBarSuccess('Usuario modificado exitosamente')),
      map(updatedUser => MaintainerUsersEffectsActions.injectUser({ updatedUser })),
      catchError(error => {
        this.showSnackBarError('El usuario no se pudo modificar');
        return throwError(MaintainerUsersEffectsActions.injectError({ error }));
      })
    )))
  );


  triggerUserStatus$ = createEffect(() => this.actions$.pipe(
    ofType(MaintainerUsersEffectsActions.triggerUserStatus),
    mergeMap(({ id, user }) => this.usersService.triggerUserStatus(id, user).pipe(
      tap(() => this.showSnackBarSuccess('Usuario modificado exitosamente')),
      map(updatedUser => MaintainerUsersEffectsActions.injectUser({ updatedUser })),
      catchError(error => {
        this.showSnackBarError('El usuario no se pudo modificar');
        return throwError(MaintainerUsersEffectsActions.injectError({ error }));
      })
    )))
  );


  constructor(
    private usersService: UsersService,
    private readonly snackBar: MatSnackBar,
    private readonly actions$: Actions,
  ) { }


  private showSnackBarSuccess(message: string): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: { type: 'success', message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }


  private showSnackBarError(message: string): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: { type: 'error', message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }
}
